<template><div></div></template>
<script>
export default {
  name: 'GoogleMapMarker',
  props: {
    loader: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    },
    google: {
      type: Object,
      required: true
    }
  },

  mounted() {
    const marker = this.marker
    const host = window.location.host
    const protocol = window.location.protocol
    const port = window.location.port
    var imagen_luminaria = ''
    if (this.marker.aaco_id === 3) {
      if (this.marker.aap_brazo.toUpperCase().includes('Doble'.toUpperCase())) {
        switch (this.marker.aap_tecnologia) {
          case 'LED':
            imagen_luminaria = '/logosiap_led_doble_apagado.png'
            break
          case 'SODIO':
            imagen_luminaria = '/logosiap_sodio_doble_apagado.png'
            break
          case 'METAL HALIDE':
            imagen_luminaria = '/logosiap_metalhalide_doble_apagado.png'
            break
          default:
            imagen_luminaria = '/logosiap_doble_apagado.png'
            break
        }
      } else {
        switch (this.marker.aap_tecnologia) {
          case 'LED':
            imagen_luminaria = '/logosiap_led_apagado.png'
            break
          case 'SODIO':
            imagen_luminaria = '/logosiap_sodio_apagado.png'
            break
          case 'METAL HALIDE':
            imagen_luminaria = '/logosiap_metalhalide_apagado.png'
            break
          default:
            imagen_luminaria = '/logosiap_apagado.png'
            break
        }
      }
    } else {
      if (this.marker.aap_brazo.toUpperCase().includes('Doble'.toUpperCase())) {
        switch (this.marker.aap_tecnologia) {
          case 'LED':
            imagen_luminaria = '/logosiap_led_doble_encendida.png'
            break
          case 'SODIO':
            imagen_luminaria = '/logosiap_sodio_doble_encendidad.png'
            break
          case 'METAL HALIDE':
            imagen_luminaria = '/logosiap_metalhalide_doble_encendida.png'
            break
          default:
            imagen_luminaria = '/logosiap_doble_encendida.png'
            break
        }
      } else {
        switch (this.marker.aap_tecnologia) {
          case 'LED':
            imagen_luminaria = '/logosiap_led_encendida.png'
            break
          case 'SODIO':
            imagen_luminaria = '/logosiap_sodio_encendida.png'
            break
          case 'METAL HALIDE':
            imagen_luminaria = '/logosiap_metalhalide_encendida.png'
            break
          default:
            imagen_luminaria = '/logosiap_encendida.png'
            break
        }
      }
    }
    const url = protocol + '//' + host + '/' + imagen_luminaria
    this.loader.importLibrary('marker').then(({ Marker }) => {
      const mark = new Marker({
        position: { lat: parseFloat(this.marker.aap_lat), lng: parseFloat(this.marker.aap_lng) },
        map: this.map,
        title: 'Luminaria No: ' + this.marker.aap_id + '\nDirección:' + this.marker.aap_direccion + '\nBarrio:' + this.marker.barr_descripcion + '\nTecnología:' + this.marker.aap_tecnologia + '\nPotencia:' + this.marker.aap_potencia + 'W',
        content: this.buildContent(this.marker),
        icon: url
      })
      // Crear una ventana de información (infoWindow) con contenido personalizado
      var contenido = this.buildContent(marker).innerHTML +
           `<div>
              <span>Poste:</span>
              <span>${this.marker.tipo_descripcion}</span>
            </div>
            <div>
              <span>Poste Altura:</span>
              <span>${this.marker.aap_poste_altura}</span>
            </div>
            <div>
              <span>Poste Propietario:</span>
              <span>${this.marker.aap_poste_propietario}</span>
            </div>
            <div>
              <span>Tipo de Conexión:</span>
              <span>${this.marker.aaco_descripcion}</span>
            </div>
            <div>
              <span>Brazo:</span>
              <span>${this.marker.aap_brazo}</span>
            </div>`
      if (this.marker.aaco_id === 2 && this.marker.medi_numero !== undefined && this.marker.medi_numero !== null) {
        contenido = contenido +
        `
          <div>
            <span>Medidor:</span>
            <span>${this.marker.medi_numero}</span>
          </div>
        `
      }
      if (this.marker.aap_numero !== undefined && this.marker.aap_numero !== null) {
        contenido = contenido +
        `
          <div>
            <span>Transformador:</span>
            <span>${this.marker.aap_numero}</span>
          </div>
        `
      }
        // +
           // `<div><button class="my-button" onclick="window.dispatchEvent(new CustomEvent('show-more-details',{ detail: { aap_id: ${this.marker.aap_id} } }))">Mostrar Más Detalles</button></div>`
      var infoWindow = new this.google.InfoWindow({
        content: contenido
      })
      // Agregar un evento de clic al marcador para mostrar la ventana de información
      mark.addListener('click', function() {
        infoWindow.open({ map: this.map, anchor: mark })
      })
    }).catch(error => {
      console.log('Marker load error:', error)
    })
  },

  methods: {
    buildContent(marker) {
      const content = document.createElement('el-content')
      content.classList.add('marca')
      content.innerHTML = `
        <el-row :gutter="20">
          <el-col :span="6">
            <h3>Luminaria No.${marker.aap_id}</h3>
          </el-col>
          <el-col :span="18">
            <div>Dirección: ${marker.aap_direccion}</div>
            <div>Barrio: ${marker.barr_descripcion}</div>
            <div>
              <div>
                <span>Tecnología:</span>
                <span>${marker.aap_tecnologia}</span>
              </div>
              <div>
                <span>Potencia:</span>
                <span>${marker.aap_potencia}W</span>
              </div>
            </div>
          </el-col>
        </el-row>
      `
      return content
    },
    showMoreDetails() {
      console.log('showMoreDetails Marker')
    }
  }
}
</script>
<style scoped>
.marca {
  align-items: center;
  background-color: #FFFFFF;
  border-radius: 50%;
  color: #263238;
  display: flex;
  font-size: 14px;
  gap: 15px;
  height: 30px;
  justify-content: center;
  padding: 4px;
  position: relative;
  position: relative;
  transition: all 0.3s ease-out;
  width: 30px;
}
</style>
